import "./grid.css";
import PaginationGrid from "./pagination";
import { useEffect, useRef } from "react";
import NoResultTable from "../../NoResultTable/NoResultTable";
import { DataGrid, GridColDef, GridSortModel } from "@mui/x-data-grid";
import PageSizeSelect from "../../PageSizeSelect/PageSizeSelect";


interface TableGridProps {
  rows?: any;
  totalPages?: number;
  setCurrentPage?: any;
  page?: number;
  columns: readonly GridColDef[];
  totalElements?: number;
  setLoading: any;
  partNumber?: string;
  setQuestionsTrue?: (value: boolean) => void;
  handleSortChange?: (model: GridSortModel) => void;
  sortModel?: GridSortModel;
  setPage?: any;
  titleGrid?: any;
  enablePageSizeSelector?: boolean;
  pageSize?: number;
  pageSizeOptions?: number[];
  onPageSizeChange?: (size: number) => void;
  fullWidth?: boolean;
}

interface PaginationSlotProps {
  totalPages?: number;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  enablePageSizeSelector: boolean;
  pageSize: number;
  pageSizeOptions: number[];
  onPageSizeChange?: (size: number) => void;
}

const PaginationSlot = ({
  totalPages,
  currentPage,
  setCurrentPage,
  enablePageSizeSelector,
  pageSize,
  pageSizeOptions,
  onPageSizeChange,
}: PaginationSlotProps) => {
  return (
    <div className="alignButtonGrid">
      {enablePageSizeSelector ? (
        <PageSizeSelect
          pageSize={pageSize}
          pageSizeOptions={pageSizeOptions}
          onPageSizeChange={onPageSizeChange}
        />
      ) : (
        <div />
      )}

      <div className="paginationRight">
        <PaginationGrid
          pages={totalPages}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        />
      </div>
    </div>
  );
};
const GenericGrid = ({
  rows = [],
  totalPages,
  columns,
  setCurrentPage,
  page,
  totalElements,
  setLoading,
  titleGrid,
  handleSortChange,
  sortModel,
  setPage,
  enablePageSizeSelector = false,
  pageSize = 6,
  pageSizeOptions = [5, 10, 20, 50, 100],
  onPageSizeChange,
  fullWidth = false,
}: TableGridProps) => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (page && totalPages && page > totalPages) {
      if (setCurrentPage) setCurrentPage(1);
      if (setPage) setPage(1);
    }
  }, [page, setCurrentPage, setPage, totalPages]);

  return (
    <div style={{ width: fullWidth ? "100%" : "92%", minHeight: "500px" }}>
      {titleGrid ? (
        <div data-testid="title-grid">{titleGrid}</div>
      ) : (
        <div className="requestContainer">
          <span>Solicitações - </span>
          <span className="numberRequest">{totalElements}</span>
        </div>
      )}

      <DataGrid
        key={JSON.stringify(rows?.map((r: any) => r.classificationId))}
        rows={rows}
        columns={columns.map((col) =>
          col.field === "createAt"
            ? { ...col, sortable: true }
            : { ...col, sortable: false },
        )}
        getRowId={(row) => `${row.classificationId}-${row.center ?? row.email}`}
        getRowClassName={(params) =>
          `row-class row-class-${params.row.classificationId}`
        }
        columnHeaderHeight={50}
        rowHeight={70}
        columnVisibilityModel={{
          classificationId: false,
          id: false,
        }}
        disableColumnMenu
        sortingMode="server"
        sortModel={sortModel}
        onSortModelChange={handleSortChange}
        sortingOrder={["asc", "desc"]}
        sx={{
          "& div div div div >.MuiDataGrid-cell": {
            borderBottom: "1px solid #71767c",
          },
          ".MuiDataGrid-columnHeaders": {
            borderBottom: "1.5px solid #000000",
          },
          ".MuiDataGrid-footerContainer": {},
          ".MuiDataGrid-virtualScrollerRenderZone": {
            position: "static !important",
          },
          ".MuiIconButton-root": {
            display: "none !important",
          },
          backgroundColor: "white",
          width: "100%",
          overflow: "hidden",
        }}
        pagination
        paginationModel={{ page: 0, pageSize }}
        pageSizeOptions={pageSizeOptions}
        disableRowSelectionOnClick={true}
        slots={{
          pagination: () => (
            <PaginationSlot
              totalPages={totalPages}
              currentPage={page ?? 1}
              setCurrentPage={setCurrentPage}
              enablePageSizeSelector={enablePageSizeSelector}
              pageSize={pageSize}
              pageSizeOptions={pageSizeOptions}
              onPageSizeChange={onPageSizeChange}
            />
          ),
          noRowsOverlay: NoResultTable,
        }}
      />
    </div>
  );
};

export default GenericGrid;
